<template>
  <img v-if="canBeShown" :src="url" style="display: none;" />
</template>

<script>
import firebase from 'firebase/app';
import { mapGetters } from 'vuex';

export default {
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['privateInfoLoading', 'googleId']),
    uid() {
      return firebase.auth().currentUser?.uid;
    },
    canBeShown() {
      return this.uid && (this.enabled || (!this.privateInfoLoading && !this.googleId));
    },
    url() {
      return `https://cm.g.doubleclick.net/pixel?google_nid=adventure_media_sarl&fv_uid=${this.uid}&google_cm`;
    },
  },
};
</script>
